import { store as secureStorage } from './SecureLS'

export const clearPersistedSession = () => {
  secureStorage.clear()
  localStorage.clear()
}
